<!-- Controller configurator -->
<script lang="ts">
  // Alex's Awesome Debugger
  import {
    isFirefox,
    showGuides,
    showStart,
    showLS,
    showRS,
    showLT,
    showRT,
    showLB,
    showRB,
    displayMode,
    controlType,
    buttonStyle,
    buttonSwap,
    controllerConnected,
  } from './stores'; /* Load Global Data */

  // import Debugger from './Debugger.svelte';

  // Import
  import Styles from './controller/Styles.svelte';
  // import Analog   from './controller/Analog.svelte';
  import Joystick from './controller/Joystick.svelte';
  import Button from './controller/Button.svelte';
  import Dpad from './controller/Dpad.svelte';
  import Trigger from './controller/Trigger.svelte';
  import Layout from './controller/Layout.svelte';
  import Settings from './controller/Settings.svelte';

  export let visible = false;
  function doNothing(event) {}

  /* Controller Layout Config */
  let osc = '174px'; /* Controller Component Size */
  let tr_size = '92px'; /* Trigger Recess Size */
  let ts_size = '80px'; /* Trigger Size */
  let tb_size = '10px'; /* Trigger Border Radius */
  let r_size = '54px'; /* Button Recess Size */
  let b_size = '42px'; /* Button Size */
  let a_size = '140px'; /* Analog Main Area Size */
  let s_size = '50px'; /* Analog Stick Size */
  let b_pad = '6px'; /* Button Padding */
  let s_pad = '45px'; /* Analog Stick Padding */
  let v_pad = '7vh'; /* Vertical Screen Padding */
  let h_pad = '3vw'; /* Horizontal Screen Padding */
  let t_pad = '20vw'; /* Horizontal Trigger Padding */
</script>

{#if visible}
  <!-- Pass Controller Layout Config into Main Div -->
  <div
    class="container only-landscape"
    id="landscape-container"
    style="--l_marg: {$showLB == 0 && $showLS == false ? '0' : osc};
              --r_marg: {$showRB == 0 && $showRS == false ? '0' : osc};
              --osc: {osc}; --tr_size: {tr_size}; --tb_size: {tb_size}; --ts_size: {ts_size};
              --r_size: {r_size}; --b_size: {b_size}; --a_size: {a_size}; --s_size: {s_size};
              --b_pad: {b_pad}; --s_pad: {s_pad}; --v_pad: {v_pad}; --h_pad: {h_pad}; --t_pad: {t_pad};
              --disp_mode: {displayMode};"
  >
    <!-- Place START Button -->
    <div class="OSCBM bottom middle {$showGuides ? 'guides' : ''} {$controllerConnected ? 'fadeout' : 'fadein'}">
      <Layout orientation={''} defaultstyle={$isFirefox} on:message />
      <!-- <Layout orientation={''} defaultstyle={$isFirefox} mapping={'swap'} on:message /> -->
    </div>

    <!-- Place LEFT Triggers -->
    {#if $showLT}
      <div class="OSCB bottom left {$showGuides ? 'guides' : ''} {$controllerConnected ? 'fadeout' : 'fadein'}">
        <Trigger
          orientation={'BM L'}
          defaultstyle={$isFirefox}
          buttonStyle={$buttonStyle}
          mapping={'LT'}
          button="lt"
          on:message
        />
        <Trigger
          orientation={'TM L'}
          defaultstyle={$isFirefox}
          buttonStyle={$buttonStyle}
          mapping={'LB'}
          button="lb"
          on:message
        />
      </div>
    {/if}

    <!-- Place RIGHT Triggers -->
    {#if $showRT}
      <div class="OSCB bottom right {$showGuides ? 'guides' : ''} {$controllerConnected ? 'fadeout' : 'fadein'}">
        <Trigger
          orientation={'BM R'}
          defaultstyle={$isFirefox}
          buttonStyle={$buttonStyle}
          mapping={'RT'}
          button="rt"
          on:message
        />
        <Trigger
          orientation={'TM R'}
          defaultstyle={$isFirefox}
          buttonStyle={$buttonStyle}
          mapping={'RB'}
          button="rb"
          on:message
        />
      </div>
    {/if}

    <!-- Place Left Controller Elements -->
    {#if $showLS}
      <div
        class="OSCL bottom {$buttonSwap
          ? 'right'
          : 'left'} centered {$showGuides ? 'guides' : ''} {$controllerConnected ? 'fadeout' : 'fadein'}"
        on:click|preventDefault={doNothing}
      >
        <Joystick
          name="left"
          on:message
          defaultstyle={$isFirefox}
          controlType={$controlType}
          buttonStyle={$buttonStyle}
          showGuides={$showGuides}
        />

        {#if $showLB == 1}
          <!-- Show D-Pad -->
          <Dpad
            orientation={'L'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'L'}
            button="left"
            on:message
          />
          <Dpad
            orientation={'T'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'U'}
            button="up"
            on:message
          />
          <Dpad
            orientation={'B'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'D'}
            button="down"
            on:message
          />
          <Dpad
            orientation={'R'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'R'}
            button="right"
            on:message
          />
        {/if}
      </div>
    {:else if $showLB == 1}
      <!-- No Joystick just D-Pad -->
      <div
        class="OSCR bottom {$buttonSwap
          ? 'right'
          : 'left'} centered {$showGuides ? 'guides' : ''} {$controllerConnected ? 'fadeout' : 'fadein'}"
        on:click|preventDefault={doNothing}
      >
        <Dpad
          orientation={'L'}
          defaultstyle={$isFirefox}
          buttonStyle={$buttonStyle}
          mapping={'L'}
          button="left"
          on:message
        />
        <Dpad
          orientation={'T'}
          defaultstyle={$isFirefox}
          buttonStyle={$buttonStyle}
          mapping={'U'}
          button="up"
          on:message
        />
        <Dpad
          orientation={'B'}
          defaultstyle={$isFirefox}
          buttonStyle={$buttonStyle}
          mapping={'D'}
          button="down"
          on:message
        />
        <Dpad
          orientation={'R'}
          defaultstyle={$isFirefox}
          buttonStyle={$buttonStyle}
          mapping={'R'}
          button="right"
          on:message
        />
      </div>
    {/if}

    <!-- Place Right Controller Elements -->
    {#if $showRS}
      <div
        class="OSCR bottom {$buttonSwap
          ? 'left'
          : 'right'} centered {$showGuides ? 'guides' : ''} {$controllerConnected ? 'fadeout' : 'fadein'}"
        on:click|preventDefault={doNothing}
      >
        <Joystick
          name="right"
          on:message
          defaultstyle={$isFirefox}
          controlType={$controlType}
          buttonStyle={$buttonStyle}
          showGuides={$showGuides}
        />

        {#if $showRB == 4}
          <Button
            orientation={'B L'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'A'}
            button="a"
            on:message
          />
          <Button
            orientation={'B R'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'B'}
            button="b"
            on:message
          />
          <Button
            orientation={'T L'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'X'}
            button="x"
            on:message
          />
          <Button
            orientation={'T R'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'Y'}
            button="y"
            on:message
          />
        {:else if $showRB == 3}
          <Button
            orientation={'B L'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'A'}
            button="a"
            on:message
          />
          <Button
            orientation={'B R'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'B'}
            button="b"
            on:message
          />
          <Button
            orientation={'T L'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'X'}
            button="x"
            on:message
          />
        {:else if $showRB == 2}
          <Button
            orientation={'B L'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'A'}
            button="a"
            on:message
          />
          <Button
            orientation={'B R'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'B'}
            button="b"
            on:message
          />
        {:else if $showRB == 1}
          <Button
            orientation={'B L'}
            defaultstyle={$isFirefox}
            buttonStyle={$buttonStyle}
            mapping={'A'}
            button="a"
            on:message
          />
        {/if}
      </div>
    {:else}
      <!-- No Joystick just buttons -->

      {#if $showRB > 0}
        <!-- No Buttons -->
        <div
          class="OSCR bottom {$buttonSwap
            ? 'left'
            : 'right'} centered {$showGuides ? 'guides' : ''} {$controllerConnected ? 'fadeout' : 'fadein'}"
          on:click|preventDefault={doNothing}
        >
          {#if $showRB == 1}
            <!-- 1 Button -->
            <Button
              orientation={''}
              defaultstyle={$isFirefox}
              buttonStyle={$buttonStyle}
              mapping={'A'}
              button="a"
              on:message
            />
          {:else if $showRB == 2}
            <!-- 2 Buttons -->
            <Button
              orientation={'BM LM'}
              defaultstyle={$isFirefox}
              buttonStyle={$buttonStyle}
              mapping={'A'}
              button="a"
              on:message
            />
            <Button
              orientation={'TM RM'}
              defaultstyle={$isFirefox}
              buttonStyle={$buttonStyle}
              mapping={'B'}
              button="b"
              on:message
            />
          {:else if $showRB == 3}
            <!-- 3 Buttons -->
            <Button
              orientation={'TM'}
              defaultstyle={$isFirefox}
              buttonStyle={$buttonStyle}
              mapping={'X'}
              button="x"
              on:message
            />
            <Button
              orientation={'BM L'}
              defaultstyle={$isFirefox}
              buttonStyle={$buttonStyle}
              mapping={'A'}
              button="a"
              on:message
            />
            <Button
              orientation={'BM R'}
              defaultstyle={$isFirefox}
              buttonStyle={$buttonStyle}
              mapping={'B'}
              button="b"
              on:message
            />
          {:else if $showRB == 4}
            <!-- 4 Buttons -->
            <Button
              orientation={'L'}
              defaultstyle={$isFirefox}
              buttonStyle={$buttonStyle}
              mapping={'X'}
              button="x"
              on:message
            />
            <Button
              orientation={'T'}
              defaultstyle={$isFirefox}
              buttonStyle={$buttonStyle}
              mapping={'Y'}
              button="y"
              on:message
            />
            <Button
              orientation={'B'}
              defaultstyle={$isFirefox}
              buttonStyle={$buttonStyle}
              mapping={'A'}
              button="a"
              on:message
            />
            <Button
              orientation={'R'}
              defaultstyle={$isFirefox}
              buttonStyle={$buttonStyle}
              mapping={'B'}
              button="b"
              on:message
            />
          {/if}
        </div>
      {/if}
    {/if}

    <!-- Placeholder for Top Menu Elements -->
    <div class="OSCT centered {$showGuides ? 'guides' : ''}">
      {#if $showStart}
        <!-- never used -->
        <Trigger
          orientation={'T'}
          defaultstyle={$isFirefox}
          buttonStyle={$buttonStyle}
          mapping={'Start'}
          button="start"
          on:message
        />
      {:else}
        <Settings orientation={''} defaultstyle={$isFirefox} on:message />
      {/if}
    </div>
  </div>
{/if}

<!-- Apply Global Controller Styles -->
<Styles />

<!-- Apply Custom Styles Here -->
<style>
  .fadein {
    opacity: 1;
    transition: all 0.5s;
  }
  .fadeout {
    opacity: 0.2;
    transition: all 0.5s;
  }
  .container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    touch-action: none !important;
  }
  .container div {
    touch-action: none !important;
  }
</style>
